import { redirect } from "react-router";

import invariant from "tiny-invariant";

import { store } from "../../../../..";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import {
    getTeamsByAgeLevel,
    getUserPlacementRatings,
} from "../../../../../lib/api";

export const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);
    let state = store.getState();
    const user = state.auth.user;

    try {
        invariant(user, "User is not logged in");
    } catch (error: any) {
        return redirect("/login");
    }

    const getSettings = state.global.settings;
    let currentTeam = selectSelectedTeam(state);
    const promises = [];

    !getSettings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !currentTeam &&
        promises.push(
            store.dispatch(clubhouseActions.getTeams({ userId: user.id })),
        );

    await Promise.all(promises);

    state = store.getState();
    const displayPlacementLink = selectSetting(
        state,
        "majorybl_display_placement_link",
    );

    if (!displayPlacementLink) {
        return redirect("/coachs-clubhouse");
    }

    const currentYear = selectSetting(state, "majorybl_current_league_year");

    if (!currentTeam) {
        store.dispatch(clubhouseActions.setSelectedTeam(teamId));
        currentTeam = selectSelectedTeam(state);
    }

    if (!currentTeam) {
        return redirect("/coachs-clubhouse");
    }

    const [{ teams }, { ratings }] = await Promise.all([
        getTeamsByAgeLevel(
            currentTeam.ageLevels.find(
                a => a.year === parseInt(currentYear?.setting),
            )!.ageLevel,
            currentYear?.setting,
        ),
        getUserPlacementRatings(user.id),
    ]);

    return {
        teamId,
        teams,
        ratings,
    };
};

export default loader;
